import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { dateTimeToView } from "helpers/date";
import { DateColumnFilter, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import React from "react";
import { list as driversList } from "sources/books/drivers";
import { list as trailersList } from "sources/books/trailers";
import { list as trucksList } from "sources/books/trucks";

class CouplingsList extends BookIndex {
    get tableColumns() {
        return [
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Грузовик",
                accessor: "car.number",
                id: "car/id",
                sortable: false,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: trucksList, inputProps: { name: "truckId" }, propName: "number" }}
                    />
                ),
            },
            {
                Header: "Прицеп",
                accessor: "trailer.number",
                id: "trailer/trailerId",
                sortable: false,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ url: trailersList, inputProps: { name: "trailerId" }, propName: "number" }}
                    />
                ),
            },
            {
                Header: "Водитель",
                accessor: "driver.fullName",
                id: "driver/id",
                sortable: false,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: driversList,
                            inputProps: { name: "driverId" },
                            propName: "user.fullName",
                            filterPropName: "user/fullName",
                        }}
                    />
                ),
            },
            {
                Header: "Второй водитель",
                accessor: "secondaryDriver.fullName",
                id: "secondaryDriver/id",
                sortable: false,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: driversList,
                            inputProps: { name: "secondaryDriverId" },
                            propName: "user.fullName",
                            filterPropName: "user/fullName",
                        }}
                    />
                ),
            },
            {
                Header: "Место смены",
                accessor: "geozone",
                sortable: false,
                filterable: false,
                Cell: ({ value }) => value?.address,
            },
            {
                Header: "Дата старта",
                accessor: "startedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Дата окончания",
                accessor: "endedAt",
                sortable: true,
                filterable: true,
                filterType: "date",
                Filter: DateColumnFilter,
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
                CSVExport: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
        ];
    }

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(CouplingsList, "couplings");
